import Swiper from "swiper";
import { Pagination } from "swiper/modules";
Swiper.use([Pagination]);

(function () {
  const byImageslider = document.querySelectorAll(".mb-imageslider");
  let imageSwiper = [];

  for (let i = 0; i < byImageslider.length; i++) {
    imageSwiper[i] = new Swiper(byImageslider[i], {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 15,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        920: {
          slidesPerView: 3,
        },
      },
    });
  }
})();
